import { Panel } from "../../../../components/panels/Panel";
import { ErgonomicsGraph } from "../ErgonomicsGraph";
import { useErgonomicsContext } from "../../../../contexts/ErgonomicsContext";

export const ErgonomicsCardMainGraphs = () => {
  return (
    <Panel title="DONNEES OBSERVEES - VUE GLOBALE TABLE A / TABLE B / TABLE C" height="full">
      <ErgonomicsGraph stepNumber={13} maxValue={12} title="Table C" />
      <ErgonomicsGraph stepNumber={4} maxValue={9} title="Table A" />
      <ErgonomicsGraph stepNumber={10} maxValue={9} title="Table B" />
    </Panel>
  );
};